import { emailToManagerIdVerify, emailToManager2ndEmail } from "../api/email";
import { useStatusMessage } from "../contexts/StatusMessageContext";
import { useApiActivity } from "../contexts/ApiActivityContext";
import type { SelectedManager } from "../types/manager";
import type { UserInfo } from "../types/user";

const useEmailManager = (
  workflow: 2 | 3,
  selectedManager: SelectedManager,
  userInfo: UserInfo
): { emailManager: () => Promise<void> } => {
  const { setStatus } = useStatusMessage();
  const { beginActivity, endActivity } = useApiActivity();

  const emailManager = async (): Promise<void> => {
    setStatus({ isError: false, isOkButtonVisible: false });

    const action = workflow === 2 ? "verify" : "add the secondary email of";
    setStatus({
      message: `Emailing ${selectedManager.managerName} to ${action} ${(userInfo as any).firstName}...`,
      isError: false,
    });

    const emailFunction =
      workflow === 2 ? emailToManagerIdVerify : emailToManager2ndEmail;
    beginActivity("manager-email");
    try {
      const { message, error } = await emailFunction(
        selectedManager.managerEmail,
        (userInfo as any).okta?.id
      );
      setStatus({
        message: message || error || "",
        isError: !!error,
        isOkButtonVisible: true,
      });
    } catch (error) {
      setStatus({
        message: `Failed to email manager: ${error}`,
        isError: true,
        isOkButtonVisible: true,
      });
    } finally {
      endActivity("manager-email");
    }
  };

  return { emailManager };
};

export default useEmailManager;
